import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';

const SearchTotalResults = ({ datasetCount, searchStatus }) => (
  <Button size="mini" className="aridhia-search-total-results">
    <Icon name="table" />
    {searchStatus !== states.PENDING && (
      <FormattedMessage
        id="search.banner.datasets"
        values={{ count: datasetCount }}
      />
    )}
    {searchStatus === states.PENDING && (
      <FormattedMessage id="actions.searching" />
    )}
  </Button>
);

export default SearchTotalResults;
